class VwHbsOrderListeDTO {
    id?: number = null;
    orderId?: number = null;
    kimlikId?: number = null;
    muracaatId?: number = null;
    hastaservisId?: number = null;
    organizasyonId?: number = null;
    tarih?: string = null;
    aciklama?: string = "";
    doktorAdi?: string = "";
    servisAdi?: string = "";
    grupId?: number = null;
    iptal?: string = "H";
    bagliOrganizasyonId?: number = null;
    onayli?: string = "H";
    numunedurum?: number = null;
}
export default VwHbsOrderListeDTO;